import { Dispatch, SetStateAction, useCallback } from 'react';
import { supabase } from '../../supabaseClient';
import { JobRecord } from '../../components/job-workspace/jobWorkspaceModel';

export interface JobWorkspaceRepository {
  updateLead(leadId: string, updates: Record<string, unknown>): Promise<void>;
}

export const supabaseJobWorkspaceRepository: JobWorkspaceRepository = {
  async updateLead(leadId, updates) {
    await supabase.from('event_leads').update(updates).eq('id', leadId);
  },
};

export const mapLeadFieldUpdate = (field: string, value: string) => {
  if (field === 'name') {
    const parts = value.trim().split(' ');
    return { first_name: parts[0] || '', last_name: parts.slice(1).join(' ') || '' };
  }
  if (field === 'eventVenue') return { venue_location: value };
  if (field === 'eventDate') return { event_date: value || null };
  return { [field]: value };
};

export const useJobWorkspace = (
  setInquiryHistory: Dispatch<SetStateAction<JobRecord[]>>,
  repository: JobWorkspaceRepository = supabaseJobWorkspaceRepository,
) => {
  const updateLeadField = useCallback(async (leadId: string, field: string, value: string) => {
    try {
      const updates = mapLeadFieldUpdate(field, value);
      await repository.updateLead(leadId, updates);
      setInquiryHistory(previous => previous.map(item => item.id === leadId ? { ...item, ...updates } : item));
    } catch (error) {
      console.error('Error updating lead:', error);
    }
  }, [repository, setInquiryHistory]);

  return { updateLeadField };
};
